export const appRouteNames = {
  AUTH: 'auth',
  MATCHES: 'matching',
  APPLICATION: 'application',
  COMPANY: 'company',
  ERROR: 'error',
  E2E_DASHBOARD: 'e2e',
  USER_PROVISIONING: 'user-provisioning',
};
